"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TARGET_TOLERANCES = exports.SUMMARY_METRIC_KEYS = exports.READINGS_POLL_INTERVAL_MS = exports.READINGS_BUCKET_MINUTES = exports.DEVICE_SERIES_COLORS = exports.BAR_METRIC_KEYS = exports.AREA_PAGE_SIZE = exports.ALL_AREAS_OPTION = void 0;
var chart_colors_1 = require("./chart-colors");
/** One day at ten-minute resolution is 144 points per device, fine for the charts and the tiles' sparklines. */
var READINGS_BUCKET_MINUTES = 10;
exports.READINGS_BUCKET_MINUTES = READINGS_BUCKET_MINUTES;
var ALL_AREAS_OPTION = { value: "all", label: "All areas" };
exports.ALL_AREAS_OPTION = ALL_AREAS_OPTION;
/** Tile order at the top of the page; anything else only gets a chart. */
var SUMMARY_METRIC_KEYS = ["temperatureC", "humidityPct", "co2Ppm", "vpd"];
exports.SUMMARY_METRIC_KEYS = SUMMARY_METRIC_KEYS;
/** How far a reading may sit from the area target before the tile turns amber; twice this turns it red. */
var TARGET_TOLERANCES = { temperatureC: 2, humidityPct: 5 };
exports.TARGET_TOLERANCES = TARGET_TOLERANCES;
/** Discrete or cumulative metrics read better as bars than lines. */
var BAR_METRIC_KEYS = ["lightStatus", "powerW", "lightingKwh", "hvacKwh", "totalFacilityKwh"];
exports.BAR_METRIC_KEYS = BAR_METRIC_KEYS;
/** One colour per device, by position in the devices list, so a device keeps its colour on every chart. */
var DEVICE_SERIES_COLORS = [
    chart_colors_1.CHART_COLORS.orange,
    chart_colors_1.CHART_COLORS.blue,
    chart_colors_1.CHART_COLORS.aqua,
    chart_colors_1.CHART_COLORS.magenta,
    chart_colors_1.CHART_COLORS.green,
    chart_colors_1.CHART_COLORS.yellow,
    chart_colors_1.CHART_COLORS.critical,
    chart_colors_1.CHART_COLORS.neutral,
    chart_colors_1.CHART_COLORS.good,
    chart_colors_1.CHART_COLORS.warning,
];
exports.DEVICE_SERIES_COLORS = DEVICE_SERIES_COLORS;
/** Matches the Sonoff sync cadence. */
var READINGS_POLL_INTERVAL_MS = 5 * 60 * 1000;
exports.READINGS_POLL_INTERVAL_MS = READINGS_POLL_INTERVAL_MS;
var AREA_PAGE_SIZE = 30;
exports.AREA_PAGE_SIZE = AREA_PAGE_SIZE;
